import {
    resourceAssignmentAreas,
    resourceCallTypes,
    resourceColorScheme,
    resourceMariTime,
    resourceStaffMembers,
    resourceSuperuserAssignmentareas,
    resourceAssignmentAreasDutiesState,
    resourceTimeFormat,
} from '../api/resources';
import { updateStaffMembers } from '../components/staff/staffUtils';
import { i18n } from '../localization';
import { getLocationPath, sortLocations } from '../components/common/helpers';

export default {
    loadColorSettings({ commit }) {
        return resourceColorScheme().then(response => {
            commit('SET_COLOR_SCHEME_ID', response.data.schemeId);
        });
    },

    setTimeout({ commit }, min) {
        commit('SET_TIMEOUT', min);
    },

    setTimeFormat({ commit }, val) {
        commit('SET_TIME_FORMAT', val);
    },

    setDefaultRecipients({ commit }, val) {
        commit('SET_DEFAULT_RECIPIENTS', val);
    },

    loadAssignmentAreas({ commit }) {
        return resourceAssignmentAreas()
            .then(response => {
                let assignmentsAreas = sortLocations(response.data);
                let allLocations = assignmentsAreas
                    .reduce((allLocations, area) => {
                        return allLocations.concat(area.locations);
                    }, [])
                    .map((location, index, allLocations) => {
                        return Object.assign(location, { path: getLocationPath(location, allLocations) });
                    });

                commit('SET_AA', assignmentsAreas);
                commit('SET_LOCATIONS', allLocations);
            })
            .catch(error => {
                commit('SET_AA', []);
                commit('SET_LOCATIONS', []);

                return Promise.reject(error);
            });
    },

    loadSuperuserAreas({ commit }) {
        return resourceSuperuserAssignmentareas()
            .then(response => {
                commit('SET_SU_AA', sortLocations(response.data));
            })
            .catch(error => {
                commit('SET_SU_AA', []);

                return Promise.reject(error);
            });
    },

    loadCallTypes({ commit }) {
        return resourceCallTypes()
            .then(response => {
                commit(
                    'SET_CALL_TYPES',
                    response.data.map(item => ({
                        id: item.id,
                        name: i18n.t('reporting.callTypes.' + item.name),
                        till: item.till,
                        time_target_enabled: item.time_target_enabled,
                        target: item.target,
                        delayed: item.delayed,
                    }))
                );
            })
            .catch(error => {
                commit('SET_CALL_TYPES', []);

                return Promise.reject(error);
            });
    },

    loadStaff({ commit }, cancelToken = undefined) {
        return resourceStaffMembers({ cancelToken })
            .then(response => {
                let staffs = Array.isArray(response.data)
                    ? updateStaffMembers(response.data)
                          .filter(staff => staff.call_id && staff.areas)
                          .map(staff => ({
                              value: staff.call_id,
                              name: staff.first_name,
                              areas: staff.areas,
                          }))
                    : [];

                commit('SET_STAFF', staffs);
            })
            .catch(() => {
                commit('SET_STAFF', []);
            });
    },

    loadMARiCurrentTime({ commit }) {
        return resourceMariTime().then(res => {
            // Browser time
            let timestamp0 = new Date().getTime();
            // MARi time
            let timestamp1 = new Date((res && res.data) || null).getTime();
            // Difference between browser and MARi time
            let delta = timestamp1 - timestamp0;

            let clock = delta ? new Date(timestamp0 + delta).getTime() : null;

            commit('SET_MARI_CURRENT_TIME', clock);
        });
    },

    loadTimeFormat({ commit }) {
        return resourceTimeFormat().then(res => {
            commit('SET_TIME_FORMAT', res.data);
        });
    },

    loadDutySelectorState({ commit }, userAreaId) {
        return resourceAssignmentAreasDutiesState({
            id: userAreaId,
        })
            .then(res => {
                res.data.overriden = res.data.duties.some(elem => elem.override !== null);
                commit('SET_DUTY_SELECTOR_STATE', res.data);
            })
            .catch(() => {
                commit('SET_DUTY_SELECTOR_STATE', { overriden: false });
            });
    },

    setDutySelectorState({ commit }, state) {
        commit('SET_DUTY_SELECTOR_STATE', state);
    },

    addOnKeyDownHandler({ commit }, { handlerName, handler }) {
        if (typeof handler === 'function') {
            commit('ADD_ONKEYDOWN_HANDLER', { handlerName, handler });
        }
    },

    removeOnKeyDownHandler({ commit }, handlerName) {
        commit('REMOVE_KEYBOARD_HANDLER', handlerName);
    },

    setTabVisibility({ commit }, tabSettings) {
        commit('user/SET_VISIBILITY_ADM', tabSettings);
    },

    setAssignmentsSettings({ commit }, assignmentsConf) {
        commit('SET_ASSIGNMENTS_CONF', assignmentsConf);
    },

    setTargetTimeSettings({ commit }, calls) {
        commit('SET_TARGET_TIME_SETTINGS', calls);
    },

    setLogSettings({ commit }, settings) {
        commit('SET_LOG_SETTINGS', settings);
    },

    startDragging({ commit }) {
        commit('SET_DRAGGING', { dragging: true });
    },

    stopDragging({ commit }) {
        commit('SET_DRAGGING', { dragging: false });
    },

    startDropAllowing({ commit }) {
        commit('SET_DROP_ALLOWING', { dropAllowing: true });
    },

    stopDropAllowing({ commit }) {
        commit('SET_DROP_ALLOWING', { dropAllowing: false });
    },
};
